<template>
  <div class="header-container" v-gsap-fade-up="{ offset: 16, duration: 0.9 }">
    <div class="logo">
      <svg
        viewBox="0 0 128 128"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M40.4087 100.025C39.7448 93.6273 41.5594 87.8886 44.3505 82.3909C47.9172 75.3655 52.6735 69.1545 57.6438 63.0852C61.0983 58.867 64.641 54.7054 67.4231 49.9826C67.7601 49.4106 68.0804 48.8188 68.3221 48.2023C69.6516 44.8122 68.2115 42.4195 64.5794 41.8425C60.7967 41.2415 57.2017 42.0531 53.692 43.3014C44.6423 46.5203 37.6717 52.3881 32.5473 60.4273C29.3598 65.4278 27.8072 70.9947 27.28 76.9118C26.6893 83.5428 27.823 89.8315 30.3977 95.9149C30.9311 97.1751 31.2762 98.4629 30.4422 99.7321C29.1199 101.744 26.5448 101.973 24.7451 100.141C22.8166 98.1772 21.1793 95.965 19.6166 93.6969C15.2208 87.3169 12.4302 80.2803 11.2752 72.647C9.91726 63.6726 10.4554 54.84 13.6429 46.2306C16.3179 39.0055 20.1324 32.5602 25.8631 27.3347C26.2716 26.9622 26.6353 26.4678 27.3524 26.4521C27.494 27.1094 27.0971 27.5222 26.824 27.9508C24.2013 32.0675 21.709 36.2527 20.1785 40.9243C19.6998 42.3855 19.2701 43.8702 18.9382 45.3707C18.208 48.6719 20.5317 50.8003 23.7459 49.7585C26.2635 48.9425 28.2419 47.2534 30.1168 45.4646C36.2276 39.6345 42.7103 34.3079 50.231 30.3539C55.5018 27.5828 61.0239 25.5257 66.9409 24.7357C70.9146 24.2051 74.9109 24.1181 78.8117 25.3651C81.0749 26.0886 83.1124 27.2196 84.6699 29.0274C87.3823 32.1754 87.4409 35.793 86.1186 39.4801C84.2369 44.7271 80.4824 48.6721 76.6155 52.4819C71.6908 57.3338 66.5258 61.9385 61.7115 66.9063C56.8802 71.8915 52.4315 77.1709 49.3051 83.4242C47.4951 87.0444 46.3024 90.8285 47.0388 94.9694C47.941 100.043 51.267 102.799 56.0135 103.873C62.1403 105.26 68.1333 104.151 73.8918 102.003C86.9443 97.132 96.885 88.5963 103.349 76.1911C105.95 71.1987 107.469 65.876 107.73 60.2001C108.191 50.1607 104.853 41.3975 98.8074 33.5876C93.3891 26.5884 86.3976 21.6926 78.02 18.8234C73.4859 17.2705 68.8042 16.695 64.0106 16.7882C56.6426 16.9314 49.9905 19.3161 43.718 22.9995C42.4982 23.7157 41.2537 24.3939 39.9919 25.033C39.0792 25.4953 38.0996 25.6366 37.0776 25.3744C35.4973 24.9691 34.6309 23.4684 35.1296 21.9114C35.5276 20.6685 36.3709 19.7609 37.4236 19.0347C42.8296 15.3055 48.8583 13.1361 55.267 11.9202C57.9258 11.4157 60.6101 11.0526 63.3114 11.0242C70.184 10.9521 76.916 11.8596 83.3466 14.401C96.5339 19.6127 106.392 28.4975 112.668 41.2532C115.754 47.5259 117.375 54.194 117.845 61.1645C118.294 67.8155 117.427 74.2992 115.352 80.6031C113.195 87.1588 109.819 93.0623 105.346 98.3295C98.4936 106.399 90.0728 112.199 79.9826 115.391C73.6717 117.388 67.1706 118.136 60.52 117.404C55.804 116.884 51.3796 115.709 47.5234 112.82C43.278 109.64 41.0327 105.346 40.4087 100.025Z"
          fill="#fff"
        />
      </svg>
      ZERO&nbsp;{{ $t("header.logoSuffix") }}
    </div>
    <div class="header-menu">
      <a href="#about">{{ $t("header.menu.about") }}</a>
      <a href="#portfolio">{{ $t("header.menu.portfolio") }}</a>
      <a href="#experience">{{ $t("header.menu.experience") }}</a>
      <a href="#team">{{ $t("header.menu.team") }}</a>
      <a href="#contact" class="underline">{{ $t("header.menu.contact") }}</a>
      <div class="language-switcher" @click.stop="toggleLanguageMenu">
        <button class="language-button">
          <span>{{ currentLanguageLabel }}</span>
        </button>
        <transition name="lang">
          <div
            v-if="isLanguageOpen"
            class="language-dropdown"
            @click.stop
          >
            <button
              v-for="option in languageOptions"
              :key="option.code"
              class="language-option"
              :class="{ active: currentLocale === option.code }"
              @click="changeLanguage(option.code)"
            >
              {{ $t(option.labelKey) }}
            </button>
          </div>
        </transition>
      </div>
      <MobileMenu class="mobile-menu" />
    </div>
  </div>
</template>

<script>
import MobileMenu from "./MobileMenu.vue";
export default {
  name: "HeaderComp",
  components: {
    MobileMenu,
  },
  data() {
    return {
      isLanguageOpen: false,
      languageOptions: [
        { code: "en", labelKey: "header.languages.en" },
        { code: "es", labelKey: "header.languages.es" },
        { code: "fr", labelKey: "header.languages.fr" },
        { code: "ru", labelKey: "header.languages.ru" },
      ],
    };
  },
  computed: {
    currentLocale() {
      return this.$i18n.locale;
    },
    currentLanguageLabel() {
      const current = this.languageOptions.find(
        (opt) => opt.code === this.currentLocale
      );
      return current ? this.$t(current.labelKey) : this.$t("header.languageLabel");
    },
  },
  methods: {
    toggleLanguageMenu() {
      this.isLanguageOpen = !this.isLanguageOpen;
    },
    changeLanguage(code) {
      this.$i18n.locale = code;
      if (typeof window !== "undefined") {
        window.localStorage.setItem("locale", code);
      }
      this.isLanguageOpen = false;
    },
    handleOutsideClick() {
      if (this.isLanguageOpen) {
        this.isLanguageOpen = false;
      }
    },
  },
  mounted() {
    document.addEventListener("click", this.handleOutsideClick);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleOutsideClick);
  },
};
</script>

<style scoped>
.header-container {
  box-sizing: border-box;
  position: fixed;
  top: 0;
  left: 0;
  padding-left: 13%;
  padding-right: 13%;
  box-sizing: border-box;
  width: 100%;
  display: flex;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  padding-top: 16px;
  padding-bottom: 16px;
  justify-content: space-between;
  align-items: center;
  border-bottom: #ffffff48 1px solid;
  background: #0000005d;
  border-radius: 0px;
  z-index: 1000;
}

.header-menu {
  display: flex;
  gap: clamp(16px, 1.67vw, 32px);
}

.language-switcher {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.language-button {
  border: none;
  outline: none;
  padding: 0;
  border-radius: 0;
  background: transparent;
  color: #fff;
  font-size: clamp(10px, 0.83vw, 16px);
  letter-spacing: 0.08em;
  text-transform: uppercase;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
}

.language-button:hover {
  opacity: 0.5;
}

.language-dropdown {
  position: absolute;
  right: 0;
  top: calc(100% + 8px);
  min-width: 160px;
  padding: 8px;
  border-radius: 16px;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
  border: 1px solid rgba(255, 255, 255, 0.12);
  display: flex;
  flex-direction: column;
  gap: 4px;
  z-index: 1200;
}

.language-option {
  border: none;
  background: transparent;
  color: #fff;
  text-align: left;
  padding: 6px 10px;
  border-radius: 999px;
  font-size: clamp(9px, 0.78vw, 14px);
  cursor: pointer;
}

.language-option:hover {
  background: rgba(255, 255, 255, 0.08);
}

.language-option.active {
  background: rgba(255, 255, 255, 0.18);
}

.lang-enter-active,
.lang-leave-active {
  transition: opacity 0.18s ease, transform 0.18s ease;
}

.lang-enter-from,
.lang-leave-to {
  opacity: 0;
  transform: translateY(6px) scale(0.98);
}

.header-menu a {
  text-decoration: none;
  color: #fff;
  transition: all 0.25s;
  font-size: clamp(10px, 0.83vw, 16px);
}

.header-menu a:hover {
  opacity: 0.5;
  transition: all 0.25s;
}

.header-menu a.underline {
  text-decoration: underline;
}

.mobile-menu {
  display: none;
}

.logo {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: clamp(8px, 0.83vw, 16px);
  font-size: clamp(10px, 0.83vw, 16px);
}

.logo SVG {
  width: clamp(32px, 3.33vw, 64px);
}

@media screen and (max-width: 1024px) {
  .mobile-menu {
    display: block;
  }

  .header-menu a {
    display: none;
  }

  .header-container {
    padding-left: 10%;
    padding-right: 10%;
  }
}

@media screen and (max-width: 768px) {
  .header-container {
    padding-left: 5%;
    padding-right: 5%;
  }
}
</style>
